import { useTranslation } from 'react-i18next';
import './PublicPage.css';

export default function TermsPage() {
    const { t } = useTranslation();
    return (
        <div className="public-page terms-page">
            <header className="public-hero">
                <div className="public-hero-content">
                    <h1>{t('terms_service.hero_title')}</h1>
                    <p>{t('terms_service.hero_subtitle')}</p>
                </div>
            </header>

            <div className="legal-content-wrapper legal-text">
                <h2>{t('terms_service.s1_title')}</h2>
                <p>{t('terms_service.s1_text')}</p>

                <h2>{t('terms_service.s2_title')}</h2>
                <p>{t('terms_service.s2_text')}</p>

                <h2>{t('terms_service.s3_title')}</h2>
                <p>{t('terms_service.s3_text')}</p>

                <h2>{t('terms_service.s4_title')}</h2>
                <p>{t('terms_service.s4_text')}</p>

                <h2>{t('terms_service.s5_title')}</h2>
                <p>{t('terms_service.s5_text')}</p>

                <h2>{t('terms_service.s6_title')}</h2>
                <p>{t('terms_service.s6_text')}</p>
                <ul className="legal-list">
                    <li>{t('terms_service.s6_list_1')}</li>
                    <li>{t('terms_service.s6_list_2')}</li>
                    <li>{t('terms_service.s6_list_3')}</li>
                    <li>{t('terms_service.s6_list_4')}</li>
                    <li>{t('terms_service.s6_list_5')}</li>
                    <li>{t('terms_service.s6_list_6')}</li>
                </ul>
                <p className="promo-notice"><strong>{t('terms_service.s6_current')}</strong></p>
            </div>
        </div>
    );
}
